import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { camelizeKeys } from 'humps';

export const useSearchParams = () => {
  const location = useLocation();

  return camelizeKeys(queryString.parse(location.search));
};
